import actionTypes from '../webActionTypes';

const reducers = {
	[actionTypes.storeScrollPosition]: function(state, action) {
		return storeScrollPosition(state, action);
	},
	[actionTypes.storeRenderedIndex]: function(state, action) {
		return storeRenderedIndex(state, action);
	},
	[actionTypes.showLogoutModal]: function(state, action) {
		return Object.assign({}, state, {
			isShowLogoutModal: true
		});
	},
	[actionTypes.closeLogoutModal]: function(state, action) {
		return Object.assign({}, state, {
			isShowLogoutModal: false
		});
	},
	// 開啟確認Dialog
	[actionTypes.openConfirmDialog]: function(state, action) {
		return openConfirmDialog(state, action);
	},
	// 關閉確認Dialog
	[actionTypes.closeConfirmDialog]: function(state, action) {
		return closeConfirmDialog(state, action);
	},
	// 開啟警告Dialog
	[actionTypes.openAlartDialog]: function(state, action) {
		return openAlartDialog(state, action);
	},
	// 關閉警告Dialog
	[actionTypes.closeAlartDialog]: function(state, action) {
		return closeAlartDialog(state, action);
	},
};

export default function createReducers(initialState) {
	return function reducer(state = initialState, action) {
		if (reducers.hasOwnProperty(action.type)) {
			return reducers[action.type](state, action);
		} else {
			return state;
		}
	};
}



function storeScrollPosition(state, action) {
	if (state.scrollPosition[action.payload.key] === action.payload.scrollTop) {
		return state;
	}

	const newScrollPosition = Object.assign({}, state.scrollPosition, {
		[action.payload.key]: action.payload.scrollTop
	});

	return Object.assign({}, state, {
		scrollPosition: newScrollPosition
	});
}

function storeRenderedIndex(state, action) {
	if (state.renderedIndex[action.payload.key] === action.payload.event) {
		return state;
	}

	const newRenderedIndex = Object.assign({}, state.renderedIndex, {
		[action.payload.key]: action.payload.event
	});

	return Object.assign({}, state, {
		renderedIndex: newRenderedIndex
	});
}

// ------------------------------
// 開啟確認Dialog
// ------------------------------
function openConfirmDialog(state, action) {

	var confirmDialog = state.confirmDialog;

	if(confirmDialog.isOpen) {
      	return state;
	}

	const payload = action.payload;

	var new_confirmDialog = Object.assign({}, confirmDialog, {
		isOpen: true,
		title: payload.title || undefined,
		description: payload.description || undefined,
		isPromise: payload.isPromise,
		confirmCallback: payload.confirmCallback || undefined,
		confirmPromise: payload.confirmPromise || undefined,
		cancelCallback: payload.cancelCallback || undefined,
		confirmName: payload.confirmName || undefined,
	});

    return Object.assign({}, state, {
        confirmDialog: new_confirmDialog,
    });
}

// ------------------------------
// 關閉確認Dialog
// ------------------------------
function closeConfirmDialog(state, action) {

	var confirmDialog = state.confirmDialog;

	if(!confirmDialog.isOpen) {
      	return state;
	}

    var new_confirmDialog = Object.assign({}, confirmDialog, {
		isOpen: false,
		title: undefined,
		description: undefined,
		isPromise: false,
		confirmCallback: undefined,
		confirmPromise: undefined,
		cancelCallback: undefined,
		confirmName: undefined,
	});

    return Object.assign({}, state, {
        confirmDialog: new_confirmDialog,
    });
}

// ------------------------------
// 開啟警告Dialog
// ------------------------------
function openAlartDialog(state, action) {

	var alartDialog = state.alartDialog;

	if(alartDialog.isOpen) {
      	return state;
	}

	const payload = action.payload;

	var new_alartDialog = Object.assign({}, alartDialog, {
		isOpen: true,
		title: payload.title || undefined,
		description: payload.description || undefined,
		confirmName: payload.confirmName || undefined,
		callback: payload.callback || undefined,
	});

    return Object.assign({}, state, {
        alartDialog: new_alartDialog,
    });
}

// ------------------------------
// 關閉警告Dialog
// ------------------------------
function closeAlartDialog(state, action) {

	var alartDialog = state.alartDialog;

	if(!alartDialog.isOpen) {
      	return state;
	}

    var new_alartDialog = Object.assign({}, alartDialog, {
		isOpen: false,
		title: undefined,
		description: undefined,
		confirmName: undefined,
		callback: undefined,
	});

    return Object.assign({}, state, {
        alartDialog: new_alartDialog,
    });
}


// WEBPACK FOOTER //
// ./src/actions/reducers/webReducers.js